import { z } from 'zod'

const configurationModeSchema = z.object({ configureAsRegularUser: z.boolean().optional() })

/** A request may opt out of privileged configuration, but can never grant itself privileges. */
export function configuresAsRegularUser(input: unknown): boolean {
  return configurationModeSchema.parse(input).configureAsRegularUser === true
}

export function regularUserConfiguration(): boolean {
  try { return localStorage.getItem('loopqa:adminMode') === '0' } catch { return false }
}
